import React, { useState } from "react";
import moment from "jalali-moment";

// import JS files
import { translateColor, translateGender } from "../../utils";

const PanelTable = (props) => {
  let colsNum = props.headers.length + 1;

  return (
    <>
      <div className="flex items-center mt-6">
        <div className="ml-2">{props.icon}</div>
        <span className="font-bold	text-gray-700 text-sm md:text-base">
          {props.header}
        </span>
      </div>
      {/* ...................Desktop Design..................... */}
      <div className="hidden sm:block md:mt-4">
        <div className="flex justify-between bg-myblue-200 opacity-80	 px-4 py-2">
          <div className={` w-full text-center basis-1/${colsNum}  `}>
            <span className={`font-bold text-sm text-white text-center  `}>
              ردیف
            </span>
          </div>

          {props.headers.map((item, index) => {
            return [
              <>
                <div className={`w-full text-center basis-1/${colsNum} `}>
                  <span className={`font-bold text-sm text-white text-center `}>
                    {item.name}
                  </span>
                </div>
              </>,
            ];
          })}
        </div>
        <div className="">
          {props.data.map((item, index) => {
            return [
              <>
                <div
                  // onClick={() => props.setSelectedRow(item)}
                  className={
                    index % 2 == 0
                      ? "bg-slate-200 flex justify-between items-center px-4 py-2"
                      : "bg-slate-100 flex justify-between items-center px-4 py-2"
                  }
                >
                  <div className={`basis-1/${colsNum} w-full text-center`}>
                    <span className={`text-sm text-center text-gray-600  `}>
                      {index + 1}
                    </span>
                  </div>
                  {props.dataKey.map((key, ind) => {
                    return [
                      <>
                        <div
                          className={`basis-1/${colsNum} w-full text-center `}
                        >
                          <span className={`text-sm text-center text-gray-600`}>
                            {key == "created_at"
                              ? moment(item[key], "YYYY/MM/DD")
                                  .locale("fa")
                                  .format("YYYY/MM/DD")
                              : key.includes("object")
                              ? item[key.split(".")[1]][key.split(".")[2]]
                              : key == "gender"
                              ? translateGender(item[key])
                              : key == "color"
                              ? translateColor(item[key])
                              : item[key]}
                          </span>
                        </div>
                      </>,
                    ];
                  })}

                  {props.buttons.map((btn, index1) => {
                    return [
                      <>
                        <div
                          className={`w-full text-center basis-1/${colsNum} `}
                          key={index1}
                        >
                          {btn.component(item)}
                        </div>
                      </>,
                    ];
                  })}
                  {props.actions.map((action, index2) => {
                    return [
                      <>
                        <div
                          className={` w-full text-center basis-1/${colsNum} `}
                        >
                          {action.component(item)}
                        </div>
                      </>,
                    ];
                  })}
                </div>
              </>,
            ];
          })}
        </div>
      </div>
      {/* ...................Mobile Design..................... */}
      <div className="sm:hidden mt-4">
        {props.data.map((item, index) => {
          return [
            <>
              <div className="panel-card mt-4">
                <span className="show-value">{index + 1}</span>
                <div className="mt-2 grid grid-cols-2 gap-x-2 gap-y-2">
                  {props.mobileHeaders.map((label, index) => {
                    return [
                      <>
                        <span className="show-label">
                          {label.name}:{" "}
                          <span className="show-value">
                            {/* {item[label.colName]} */}
                            {label.colName == "created_at"
                              ? moment(item[label.colName], "YYYY/MM/DD")
                                  .locale("fa")
                                  .format("YYYY/MM/DD")
                              : label.colName == "gender"
                              ? translateGender(item[label.colName])
                              : label.colName == "color"
                              ? translateColor(item[label.colName])
                              : item[label.colName]}
                          </span>
                        </span>
                      </>,
                    ];
                  })}
                </div>
                <div className="flex justify-between mt-2">
                  <div className="">
                    {props.buttons.map((btn, index) => {
                      return [
                        <>
                          <div
                            className="flex items-center"
                            key={(Math.random() + 1).toString(36).substring(7)}
                          >
                            <span className="show-label">{btn.label}: </span>
                            <span
                              className="show-value mr-1"
                              // onClick={() => props.setSelectedRow(item)}
                            >
                              {btn.component(item)}
                            </span>
                          </div>
                        </>,
                      ];
                    })}
                  </div>
                  <div className="">
                    {props.actions.map((action, index) => {
                      return [
                        <>
                          <div className="flex items-center">
                            <span className="show-label">{action.label}: </span>
                            <span className="show-value mr-1">
                              {action.component(item)}
                            </span>
                          </div>
                        </>,
                      ];
                    })}
                  </div>
                </div>
              </div>
            </>,
          ];
        })}
      </div>
    </>
  );
};

export default PanelTable;
